import React from 'react'
import ReactWOW from 'react-wow'
import { Link, useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const Banner = () => {
  const { heroSection } = useStaticQuery(
    graphql`
      query {
        heroSection: allContentfulHomeItServices {
          edges {
            node {
              heroTitle
              heroContent {
                heroContent
              }
              heroButtonLink
              heroButtonText
              heroImage {
                fluid(maxWidth: 750) {
                  ...GatsbyContentfulFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    `
  )

  const {
    heroTitle,
    heroContent,
    heroButtonLink,
    heroButtonText,
    heroImage,
  } = heroSection.edges[0].node

  return (
    <div className="it-services-banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="main-banner-content">
              <ReactWOW delay=".1s" animation="fadeInLeft">
                <h1>{heroTitle}</h1>
              </ReactWOW>
              <ReactWOW delay=".1s" animation="fadeInLeft">
                <p>{heroContent.heroContent}</p>
              </ReactWOW>
              <ReactWOW delay=".1s" animation="fadeInRight">
                <div className="btn-box">
                  <Link to={heroButtonLink} className="default-btn">
                    <i className="flaticon-right"></i>
                    {heroButtonText} <span></span>
                  </Link>
                </div>
              </ReactWOW>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <ReactWOW delay=".1s" animation="fadeInUp">
              <div className="main-banner-image">
                <Img loading="eager" fadeIn={false} fluid={heroImage.fluid} />
              </div>
            </ReactWOW>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
